const tintColorLight = "#2f95dc";
const tintColorDark = "#fff";
import { Platform } from "react-native";

export default {
  light: {
    text: "#000",
    background: "#fff",
    tint: tintColorLight,
    tabIconDefault: "#ccc",
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: "#fff",
    background: "#000",
    tint: tintColorDark,
    tabIconDefault: "#ccc",
    tabIconSelected: tintColorDark,
  },
  background: "#F6F8FB",
  base_colors_white: "#fff",
  base_colors_black: "#000",
  go_blue_100: "#BBDEFF",
  go_blue_600: "#0C6FDB",
  go_danger_200: "#FFA9A3",
  go_danger_500: "#FF3B30",
  coral_500: "#FF5347",
  nuetral_grey_100: "#FAFAFA",
  nuetral_grey_200: "#F5F5F5",
  nuetral_grey_400: "#E0E0E0",
  nuetral_grey_600: "#999999",
  nuetral_grey_700: "#666666",
  primary_500: "#75c2c3",
  brand_dark: "#336E7B",
  brand_lightest: "#EEF9F9",
  semantic_red_100: "#FA423C",
  text_accent: "#8C8C8C",
  tinted_grey_100: "#F9FBFB",
  tinted_grey_300: "#ECEFEF",
  tinted_yellow_200: "#FAE4C3",
  tinted_yellow_600: "#E59722",
};
